"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var store = require('../../../../../config/store');
var _require = require('./checkoutConfiguration'),
  setCheckoutConfiguration = _require.setCheckoutConfiguration,
  actionHandler = _require.actionHandler;
var _require2 = require('adyen_custom/adyen/checkout/renderPaymentMethod'),
  renderCheckout = _require2.renderCheckout;
var _require3 = require('./helpers'),
  showValidation = _require3.showValidation,
  paymentFromComponent = _require3.paymentFromComponent;
var billing = require('../../checkout/billing');
var _require4 = require('../commons/httpClient'),
  httpClient = _require4.httpClient;
var _require5 = require('../commons'),
  getPaymentMethods = _require5.getPaymentMethods;
var _require6 = require('../../../../../config/constants'),
  GIFTCARD = _require6.GIFTCARD;
var _require7 = require('./giftcards'),
  renderGiftCards = _require7.renderGiftCards;
var _require8 = require('./pos'),
  addStores = _require8.addStores;
var helpers = require('./helpers');
var _require9 = require('./fastlane'),
  mountFastlaneWatermark = _require9.mountFastlaneWatermark,
  fastlaneAuthenticate = _require9.fastlaneAuthenticate,
  initFastlane = _require9.initFastlane,
  getFastlaneShopperDetails = _require9.getFastlaneShopperDetails;
var paymentMethodsResponse = null;
var isFastlaneRendering = false;
function checkForError() {
  var name = 'paymentError';
  var error = new RegExp("[?&]".concat(encodeURIComponent(name), "=([^&]*)")).exec(window.location.search);
  if (error) {
    $('.error-message').show();
    $('.error-message-text').text(decodeURIComponent(error[1]));
  }
}
console.log('app_adyen_sfra/adyen/checkout/index.js initialized');
$(document).ready(function () {
  checkForError();
});
function renderFastlane(_x) {
  return _renderFastlane.apply(this, arguments);
}
function _renderFastlane() {
  _renderFastlane = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(shopperEmail) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          if (!isFastlaneRendering) {
            _context6.next = 2;
            break;
          }
          return _context6.abrupt("return");
        case 2:
          isFastlaneRendering = true;
          _context6.prev = 3;
          _context6.next = 6;
          return fastlaneAuthenticate(shopperEmail);
        case 6:
          _context6.next = 10;
          break;
        case 8:
          _context6.prev = 8;
          _context6.t0 = _context6["catch"](3);
        case 10:
          _context6.prev = 10;
          isFastlaneRendering = false;
          return _context6.finish(10);
        case 13:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[3, 8, 10, 13]]);
  }));
  return _renderFastlane.apply(this, arguments);
}
function renderGiftCardsIfEnabled() {
  return _renderGiftCardsIfEnabled.apply(this, arguments);
}
function _renderGiftCardsIfEnabled() {
  _renderGiftCardsIfEnabled = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var _paymentMethodsRespon3, _paymentMethodsRespon4, _paymentMethodsRespon5;
    var areGiftCardsEnabled;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          areGiftCardsEnabled = (_paymentMethodsRespon3 = paymentMethodsResponse) === null || _paymentMethodsRespon3 === void 0 ? void 0 : (_paymentMethodsRespon4 = _paymentMethodsRespon3.AdyenPaymentMethods) === null || _paymentMethodsRespon4 === void 0 ? void 0 : (_paymentMethodsRespon5 = _paymentMethodsRespon4.paymentMethods) === null || _paymentMethodsRespon5 === void 0 ? void 0 : _paymentMethodsRespon5.some(function (pm) {
            return pm.type === GIFTCARD;
          });
          if (!areGiftCardsEnabled) {
            _context7.next = 5;
            break;
          }
          document.querySelector('#adyenGiftCards').style.display = 'block';
          _context7.next = 5;
          return renderGiftCards(paymentMethodsResponse);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _renderGiftCardsIfEnabled.apply(this, arguments);
}
function registerRenderPaymentMethodListener() {
  return _registerRenderPaymentMethodListener.apply(this, arguments);
}
function _registerRenderPaymentMethodListener() {
  _registerRenderPaymentMethodListener = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          $('body').on('checkout:renderPaymentMethod', /*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e, response) {
              var email, amount, _paymentMethodsRespon6, showFastlane, shopperEmail, fastlane;
              return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                while (1) switch (_context8.prev = _context8.next) {
                  case 0:
                    email = response.email, amount = response.amount;
                    _paymentMethodsRespon6 = paymentMethodsResponse, showFastlane = _paymentMethodsRespon6.showFastlane, shopperEmail = _paymentMethodsRespon6.shopperEmail;
                    fastlane = store.fastlane;
                    if (!(fastlane.component && showFastlane && shopperEmail)) {
                      _context8.next = 6;
                      break;
                    }
                    _context8.next = 6;
                    return renderFastlane(shopperEmail);
                  case 6:
                    _context8.next = 8;
                    return setCheckoutConfiguration({
                      email: email,
                      paymentMethodsResponse: paymentMethodsResponse,
                      amount: amount
                    });
                  case 8:
                    _context8.next = 10;
                    return renderCheckout(paymentMethodsResponse);
                  case 10:
                    _context8.next = 12;
                    return renderGiftCardsIfEnabled();
                  case 12:
                    if (window.activeTerminalApiStores) {
                      addStores(window.activeTerminalApiStores);
                    }
                    $('body').trigger('checkout:selectFirstPaymentMethod');
                    window.arePaymentMethodsRendering = false;
                  case 15:
                  case "end":
                    return _context8.stop();
                }
              }, _callee8);
            }));
            return function (_x13, _x14) {
              return _ref5.apply(this, arguments);
            };
          }());
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _registerRenderPaymentMethodListener.apply(this, arguments);
}
function assignPaymentMethodValue() {
  var adyenPaymentMethod = document.querySelector('#adyenPaymentMethodName');
  // if currently selected paymentMethod contains a brand it will be part of the label ID
  var paymentMethodlabelId = "#lb_".concat(store.selectedMethod);
  if (adyenPaymentMethod) {
    var _document$querySelect;
    adyenPaymentMethod.value = store.brand ? store.brand : (_document$querySelect = document.querySelector(paymentMethodlabelId)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.innerHTML;
    if (store.selectedMethod === 'scheme') { // TODO: FED team, Please use the right way to fetch the value as Credit Card. Currently it is fetching the complete html. Please move this change to int_adyen_sfra_custom
      adyenPaymentMethod.value = 'Credit Card';
    }
  }
}
function setAdyenInputValues() {
  var customMethods = {};
  if (store.selectedMethod in customMethods) {
    customMethods[store.selectedMethod]();
  }
  document.querySelector('#adyenStateData').value = JSON.stringify(store.stateData);
  if (store.partialPaymentsOrderObj) {
    document.querySelector('#adyenPartialPaymentsOrder').value = JSON.stringify(store.partialPaymentsOrderObj);
  }
}
function handleSfraRedirect(data) {
  if (window.sfra6Compatibility) {
    var redirect = $('<form>').appendTo(document.body).attr({
      method: 'POST',
      action: data.continueUrl
    });
    $('<input>').appendTo(redirect).attr({
      name: 'orderID',
      value: data.orderID
    });
    $('<input>').appendTo(redirect).attr({
      name: 'orderToken',
      value: data.orderToken
    });
    redirect.submit();
  } else {
    var continueUrl = data.continueUrl;
    var urlParams = {
      ID: data.orderID,
      token: data.orderToken
    };
    continueUrl += (continueUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(urlParams).map(function (key) {
      return "".concat(key, "=").concat(encodeURIComponent(urlParams[key]));
    }).join('&');
    window.location.href = continueUrl;
  }
}
function overridePlaceOrderRequest(_x2) {
  return _overridePlaceOrderRequest.apply(this, arguments);
}
function _overridePlaceOrderRequest() {
  _overridePlaceOrderRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee0(url) {
    var data;
    return _regeneratorRuntime().wrap(function _callee0$(_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          _context0.prev = 0;
          $('body').trigger('checkout:disableButton', '.next-step-button button');
          _context0.next = 4;
          return httpClient({
            url: url,
            method: 'POST'
          });
        case 4:
          data = _context0.sent;
          if (data.error) {
            if (data.cartError) {
              window.location.href = data.redirectUrl;
            } else {
              $('body').trigger('checkout:enableButton', '.next-step-button button');
              $('.error-message').show();
              $('.error-message-text').text(data.errorMessage);
            }
          } else if (data.adyenAction) {
            window.orderToken = data.orderToken;
            actionHandler(data.adyenAction);
          } else {
            handleSfraRedirect(data);
          }
          _context0.next = 11;
          break;
        case 8:
          _context0.prev = 8;
          _context0.t0 = _context0["catch"](0);
          $('body').trigger('checkout:enableButton', '.next-step-button button');
        case 11:
        case "end":
          return _context0.stop();
      }
    }, _callee0, null, [[0, 8]]);
  }));
  return _overridePlaceOrderRequest.apply(this, arguments);
}
function submitPayment() {
  $('#dwfrm_billing').submit(/*#__PURE__*/function () {
    var _apiRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var form, formDataObject, url, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            form = $(this);
            formDataObject = form.serializeArray().reduce(function (obj, item) {
              obj[item.name] = item.value;
              return obj;
            }, {});
            url = form.attr('action');
            _context.next = 6;
            return httpClient({
              method: 'POST',
              url: url,
              data: formDataObject
            });
          case 6:
            data = _context.sent;
            store.formErrorsExist = 'fieldErrors' in data;
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function apiRequest(_x3) {
      return _apiRequest.apply(this, arguments);
    }
    return apiRequest;
  }());

  // Submit the payment
  $('button[value="submit-payment"]').on('click', function () {
    if (store.paypalTerminatedEarly) {
      paymentFromComponent({
        cancelTransaction: true,
        merchantReference: document.querySelector('#merchantReference').value
      });
      store.paypalTerminatedEarly = false;
    }
    // var selectedPaymentOption = $('.payment-options .nav-item .active').parent().attr('data-method-id');
    var selectedPaymentOption = $('.selected-payment-method').attr('data-method-id');
    $('#selectedPaymentOption').val(selectedPaymentOption);
    if (selectedPaymentOption === 'AdyenPOS') {
      document.querySelector('#terminalId').value = document.querySelector('#terminalList').value;
    }
    if (selectedPaymentOption === 'AdyenComponent' || selectedPaymentOption === 'CREDIT_CARD') {
      assignPaymentMethodValue();
      setAdyenInputValues();
      return showValidation();
    }
    return true;
  });
}
function handleSubmitCustomerResponse(response) {
  if (response.redirectUrl || response.fastlaneReturnUrl) {
    window.location.href = response.redirectUrl || response.fastlaneReturnUrl;
  } else {
    $('body').trigger('checkout:updateCheckoutView', {
      order: response.order,
      customer: response.customer,
      csrfToken: response.csrfToken
    });
  }
}
function submitCustomer(_x4, _x5) {
  return _submitCustomer.apply(this, arguments);
}
function _submitCustomer() {
  _submitCustomer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee1(url, shopperEmail) {
    var _store$fastlane$authR, authenticationState, profileData, shopperDetails, requestData, response;
    return _regeneratorRuntime().wrap(function _callee1$(_context1) {
      while (1) switch (_context1.prev = _context1.next) {
        case 0:
          _store$fastlane$authR = store.fastlane.authResult, authenticationState = _store$fastlane$authR.authenticationState, profileData = _store$fastlane$authR.profileData;
          shopperDetails = getFastlaneShopperDetails(shopperEmail, authenticationState, profileData);
          requestData = {
            dwfrm_coCustomer_email: shopperEmail
          };
          if (shopperDetails) {
            requestData.fastlaneShopperDetails = JSON.stringify(shopperDetails);
          }
          _context1.next = 6;
          return httpClient({
            url: url,
            data: requestData,
            method: 'POST'
          });
        case 6:
          response = _context1.sent;
          handleSubmitCustomerResponse(response);
        case 8:
        case "end":
          return _context1.stop();
      }
    }, _callee1);
  }));
  return _submitCustomer.apply(this, arguments);
}
function handleFastlaneFlow(_x6) {
  return _handleFastlaneFlow.apply(this, arguments);
}
function _handleFastlaneFlow() {
  _handleFastlaneFlow = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(url) {
    var guestButton, shopperEmail, _err$responseJSON;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          guestButton = document.querySelector('#guest-customer button');
          guestButton.disabled = true;
          _context10.prev = 2;
          shopperEmail = document.querySelector('#email-guest').value;
          _context10.next = 6;
          return fastlaneAuthenticate(shopperEmail);
        case 6:
          _context10.next = 8;
          return submitCustomer(url, shopperEmail);
        case 8:
          _context10.next = 13;
          break;
        case 10:
          _context10.prev = 10;
          _context10.t0 = _context10["catch"](2);
          if ((_err$responseJSON = _context10.t0.responseJSON) !== null && _err$responseJSON !== void 0 && _err$responseJSON.redirectUrl) {
            window.location.href = _context10.t0.responseJSON.redirectUrl;
          }
        case 13:
          _context10.prev = 13;
          guestButton.disabled = false;
          return _context10.finish(13);
        case 16:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[2, 10, 13, 16]]);
  }));
  return _handleFastlaneFlow.apply(this, arguments);
}
function handlePaymentAction() {
  var shouldResend = true;
  $(document).ajaxSend(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event, xhr, settings) {
      var isCustomerEmailUrl, isPlaceOrderUrl;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            isCustomerEmailUrl = settings.url === $('#guest-customer').attr('action');
            if (!(isCustomerEmailUrl && store.fastlane.component)) {
              _context2.next = 5;
              break;
            }
            xhr.abort();
            _context2.next = 5;
            return handleFastlaneFlow(settings.url);
          case 5:
            isPlaceOrderUrl = settings.url === $('.place-order').data('action');
            if (!(isPlaceOrderUrl && shouldResend)) {
              _context2.next = 11;
              break;
            }
            xhr.abort();
            shouldResend = false;
            _context2.next = 11;
            return overridePlaceOrderRequest(settings.url);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x7, _x8, _x9) {
      return _ref.apply(this, arguments);
    };
  }());
  $(document).ajaxComplete(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event, xhr, settings) {
      var isSelectShippingMethod;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            isSelectShippingMethod = settings.url && settings.url.includes('CheckoutShippingServices-SelectShippingMethod');
            if (!(isSelectShippingMethod && xhr.status === 200)) {
              _context3.next = 6;
              break;
            }
            _context3.next = 4;
            return getPaymentMethods();
          case 4:
            paymentMethodsResponse = _context3.sent;
            $('body').trigger('checkout:renderPaymentMethod', {
              email: paymentMethodsResponse.shopperEmail
            });
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x0, _x1, _x10) {
      return _ref2.apply(this, arguments);
    };
  }());
}
function registerUpdateCheckoutView() {
  $('body').on('checkout:updateCheckoutView', /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(event, data) {
      var _shipping$0$shippingA, _paymentMethodsRespon;
      var shipping, _data$order;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            shipping = data.order.shipping;
            if (!(shipping.length && ((_shipping$0$shippingA = shipping[0].shippingAddress) === null || _shipping$0$shippingA === void 0 ? void 0 : _shipping$0$shippingA.countryCode.value) !== ((_paymentMethodsRespon = paymentMethodsResponse) === null || _paymentMethodsRespon === void 0 ? void 0 : _paymentMethodsRespon.countryCode))) {
              _context4.next = 6;
              break;
            }
            _context4.next = 4;
            return getPaymentMethods();
          case 4:
            paymentMethodsResponse = _context4.sent;
            $('body').trigger('checkout:renderPaymentMethod', {
              email: data === null || data === void 0 ? void 0 : (_data$order = data.order) === null || _data$order === void 0 ? void 0 : _data$order.orderEmail
            });
          case 6:
            billing.methods.updatePaymentInformation(data.order, data.options);
          case 7:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x11, _x12) {
      return _ref3.apply(this, arguments);
    };
  }());
}
function registerEmailChangeHandler() {
  var emailSFRA5 = document.getElementsByName('dwfrm_billing_contactInfoFields_email');
  if (emailSFRA5.length) {
    emailSFRA5[0].addEventListener('change', function (e) {
      var emailPattern = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
      if (emailPattern.test(e.target.value)) {
        var _e$target$value;
        $('body').trigger('checkout:renderPaymentMethod', {
          email: (_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.trim()
        });
      }
    });
  }
}
function registerFirstPaymentMethod() {
  $('body').on('checkout:selectFirstPaymentMethod', function () {
    var firstPaymentMethod = document.querySelector('input[type=radio][name=brandCode]');
    if (firstPaymentMethod) {
      firstPaymentMethod.checked = true;
      helpers.displaySelectedMethod(firstPaymentMethod.value);
    }
  });
}
function init() {
  $(document).ready(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _paymentMethodsRespon2, showFastlane, guestEmailInput;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return getPaymentMethods();
        case 2:
          paymentMethodsResponse = _context5.sent;
          _paymentMethodsRespon2 = paymentMethodsResponse, showFastlane = _paymentMethodsRespon2.showFastlane;
          if (!showFastlane) {
            _context5.next = 11;
            break;
          }
          _context5.next = 7;
          return initFastlane();
        case 7:
          guestEmailInput = document.querySelector('#email-guest');
          if (!guestEmailInput) {
            _context5.next = 11;
            break;
          }
          _context5.next = 11;
          return mountFastlaneWatermark(guestEmailInput);
        case 11:
          $('body').trigger('checkout:renderPaymentMethod', {
            email: paymentMethodsResponse.shopperEmail
          });
          helpers.createShowConfirmationForm(window.ShowConfirmationPaymentFromComponent);
        case 13:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  })));
}
module.exports = {
  submitPayment: submitPayment,
  handlePaymentAction: handlePaymentAction,
  registerUpdateCheckoutView: registerUpdateCheckoutView,
  registerEmailChangeHandler: registerEmailChangeHandler,
  registerRenderPaymentMethodListener: registerRenderPaymentMethodListener,
  registerFirstPaymentMethod: registerFirstPaymentMethod,
  init: init,
  setAdyenInputValues: setAdyenInputValues
};